<template>
	<div class="center_main_top_box">
		<!-- 头像部分 -->
		<div class="center_main_top_avatar">
			<!-- 头像 -->
			<el-upload :action="$URL.baseUrl+'index/information/picture'" :show-file-list="false" with-credentials
				class="avatar_uploader">
				<img v-if="main_info.user.avatar" v-lazy="main_info.user.avatar" class="avatar">
				<i v-else class="el-icon-plus avatar_uploader_icon"></i>
			</el-upload>
			<!-- 名称 -->
			<div class="center_main_top_username">
				<!-- 名称 -->
				<div>
					<span class="text">{{$t("message.cmain.welc")}}</span>
					<span class="text">{{main_info.user.truename}}</span>
				</div>
				<div style="display: flex;align-items: center;">
					<!-- 剩余金额 -->
					<!-- 	<div style="margin-right: 20px;" v-if="main_info.user.month !== ''">
					    <span  class="text">{{$t("message.cmain.surplus")}}</span>
					    <span  class="text">{{currency}}</span>
					    <span  class="text">{{main_info.user.month}}</span>
					</div> -->
					<!-- 全年总额 -->
					<!-- <div v-if="main_info.user.all_accumulative && main_info.user.all_accumulative.year !== ''">
					    <span  class="text">{{$t("message.cmain.surplus2")}}</span>
					    <span  class="text">{{currency}}</span>
					    <span  class="text">{{main_info.user.all_accumulative.year}}</span>
					</div> -->
				</div>
			</div>
		</div>
		<div class="money" v-if="main_info.user.all_accumulative">
			<!-- 全年可用金额 -->
			<div class="money-item" v-if="main_info.user.all_accumulative.all_year!=''">
				<span class="text">全年可用金額：</span>
				<span class="text">{{currency}}</span>
				<span class="text">{{main_info.user.all_accumulative.all_year}}</span>
			</div>
			<!-- 當月分配金額 -->
			<div class="money-item" v-if="main_info.user.all_accumulative.now_month!=''">
				<span class="text">當月分配金額：</span>
				<span class="text">{{currency}}</span>
				<span class="text">{{main_info.user.all_accumulative.now_month}}</span>
			</div>
			<!-- 全年已使用金额 -->
			<div class="money-item" v-if="main_info.user.all_accumulative.use_year!=''">
				<span class="text">全年已使用金额：</span>
				<span class="text">{{currency}}</span>
				<span class="text">{{main_info.user.all_accumulative.use_year}}</span>
			</div>
			<!-- 當月可用餘額 -->
			<div class="money-item" v-if="main_info.user.all_accumulative.now!=''">
				<span class="text">當月可用餘額：</span>
				<span class="text">{{currency}}</span>
				<span class="text">{{main_info.user.all_accumulative.now}}</span>
			</div>
			<!-- 全年可用餘额 -->
			<div class="money-item" v-if="main_info.user.all_accumulative.year!=''">
				<span class="text">全年可用餘额：</span>
				<span class="text">{{currency}}</span>
				<span class="text">{{main_info.user.all_accumulative.year}}</span>
			</div>
			<!-- 累計至上月餘額 -->
			<div class="money-item" v-if="main_info.user.all_accumulative.last_month!=''">
				<span class="text">累計至上月餘額：</span>
				<span class="text">{{currency}}</span>
				<span class="text">{{main_info.user.all_accumulative.last_month }}</span>
			</div>
		</div>
		<!-- <div class="money" v-if="main_info.user.all_accumulative">
			
			<div class="money-item" v-if="main_info.user.all_accumulative.now_month!=''">
				<span  class="text">當月分配金額</span>
				<span  class="text">{{currency}}</span>
				<span  class="text">{{main_info.user.all_accumulative.now_month}}</span>
			</div>
			
			<div class="money-item" v-if="main_info.user.all_accumulative.now!=''">
				<span  class="text">當月可用餘額</span>
				<span  class="text">{{currency}}</span>
				<span  class="text">{{main_info.user.all_accumulative.now}}</span>
			</div>
			
			<div class="money-item" v-if="main_info.user.all_accumulative.last_month!=''">
				<span  class="text">累計至上月餘額</span>
				<span  class="text">{{currency}}</span>
				<span  class="text">{{main_info.user.all_accumulative.last_month }}</span>
			</div>	
		</div> -->



		<!-- 个人信息部分 -->
		<div class="center_main_top_info">
			<el-row :gutter="30">
				<!-- 优惠等级 -->
				<el-col :span="8">
					<div class="center_main_top_info_item">
						<img v-lazy="require('@/assets/img/centerMain/king.png')" alt="">
						<span>{{$t("message.cmain.level")}}</span>
						<el-tooltip placement="left-end" :content="main_info.user.name" effect="dark">
							<span>{{main_info.user.name}}</span>
						</el-tooltip>
					</div>
				</el-col>
				<!-- 积分 -->
				<el-col :span="8">
					<div class="center_main_top_info_item">
						<img v-lazy="require('@/assets/img/centerMain/lv.png')" alt="">
						<span>{{$t("message.cmain.score")}}</span>
						<el-tooltip placement="left-end" :content="String(main_info.user.score)" effect="dark">
							<span>{{main_info.user.score}}</span>
						</el-tooltip>
					</div>
				</el-col>
				<!-- 公司名称/真实姓名 -->
				<el-col :span="8">
					<div class="center_main_top_info_item">
						<img v-lazy="require('@/assets/img/centerMain/name.png')" alt="">
						<span>{{judgeCompany.title}}</span>
						<el-tooltip placement="left-end" :content="judgeCompany.msg" effect="dark">
							<span>{{judgeCompany.msg}}</span>
						</el-tooltip>
					</div>
				</el-col>
				<!-- email -->
				<el-col :span="8">
					<div class="center_main_top_info_item">
						<img v-lazy="require('@/assets/img/centerMain/email.png')" alt="">
						<span>{{$t("message.cmain.email")}}</span>
						<el-tooltip placement="left-end" :content="main_info.user.email" effect="dark">
							<span>{{main_info.user.email}}</span>
						</el-tooltip>
					</div>
				</el-col>
				<!-- 注册IP -->
				<el-col :span="8">
					<div class="center_main_top_info_item">
						<img v-lazy="require('@/assets/img/centerMain/ip.png')" alt="">
						<span>{{$t("message.cmain.uid")}}</span>
						<el-tooltip placement="left-end" :content="main_info.user.user_id" effect="dark">
							<span>{{main_info.user.user_id}}</span>
						</el-tooltip>
					</div>
				</el-col>
				<!-- 注册时间 -->
				<el-col :span="8">
					<div class="center_main_top_info_item">
						<img v-lazy="require('@/assets/img/centerMain/time.png')" alt="">
						<span>{{$t("message.cmain.createtime")}}</span>
						<el-tooltip placement="left-end" :content="main_info.user.createtime | getTime" effect="dark">
							<span>{{main_info.user.createtime | getTime}}</span>
						</el-tooltip>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- 订单相关信息 -->
		<ul class="center_main_top_order">
			<li class="center_main_top_order_num" v-if="power.includes(0) || power.includes(20) || power.includes(111)">
				<router-link to="/center/cart">
					<div>{{$t("message.cmain.cart")}}</div>
					<div>{{main_info.order.cart}}</div>
				</router-link>
			</li>
			<!-- <li class="center_main_top_order_border" v-if="power.includes(0) || power.includes(20)">|</li> -->
			<li class="center_main_top_order_num" v-if="power.includes(0) || power.includes(17) || power.includes(111)">
				<router-link to="/center/collection">
					<div>{{$t("message.cmain.collection")}}</div>
					<div>{{main_info.order.collection}}</div>
				</router-link>
			</li>
			<!-- <li class="center_main_top_order_border" v-if="power.includes(0) || power.includes(17)">|</li> -->
			<li class="center_main_top_order_num" v-if="power.includes(0) || power.includes(18) || power.includes(111)">
				<router-link to="/center/quoteCart">
					<div>{{$t("message.cmain.qcart")}}</div>
					<div>{{main_info.order.quote}}</div>
				</router-link>
			</li>
			<!-- <li class="center_main_top_order_border" v-if="power.includes(0) || power.includes(18)">|</li> -->
			<li class="center_main_top_order_num" v-if="power.includes(0) || power.includes(11) || power.includes(111)">
				<router-link to="/center/orderStatus">
					<div>{{$t("message.cmain.ordernum")}}</div>
					<div>{{main_info.order.mine_order}}</div>
				</router-link>
			</li>
			<li class="center_main_top_order_num" v-if="(character_id!=3 || power.includes(111)) && (power.includes(0) || power.includes(11))">
				<router-link to="/center/orderStatus">
					<div>{{$t("message.cmain.ordermine")}}</div>
					<div >{{main_info.order.other_order}}</div>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'

	export default {
		filters: {
			getTime(val) {
				let date = new Date(val * 1000);
				let Y = date.getFullYear() + '-',
					M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-',
					D = date.getDate() + ' ';
				return Y + M + D;
			},
		},
		computed: mapState({
			power: state => state.user.power,
			character_id: state => state.user.character_id,
			main_info: state => state.user.main_info,
			currency: state => state.currency,
			judgeCompany() {
				let company = this.main_info.company;
				if (Array.isArray(company)) {
					return {
						title: this.$t("message.cmain.truename"),
						msg: this.main_info.user.truename
					}
				} else {
					return {
						title: this.$t("message.cmain.company"),
						msg: this.main_info.company.companyname
					}
				}
			}
		}),
		mounted() {
			// console.log("查看",this.main_info)
	
	}
}
</script>

<style scoped>
	.money {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		margin: 0px 25px;
		margin-bottom: 30px;
	}

	.money-item {
		width: 350px;
		padding-left: 16px;
		padding-top: 10px;
	}

	.text {
		font-size: 16px;
		font-weight: bold;
	}

	/* 组件盒子 */
	.center_main_top_box {
		background-color: #fff
	}


	/* 头像部分 */
	.center_main_top_avatar {
		padding: 20px 0;
		display: flex;
		align-items: center;
	}

	/* 头像组件 */
	.avatar_uploader {
		display: inline-block;
		vertical-align: middle;
		margin-left: 50px;
	}

	.avatar_uploader>>>.el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar_uploader>>>.el-upload:hover {
		border-color: #409EFF;
	}

	.avatar_uploader>>>.el-upload__input {
		display: none;
	}

	.avatar_uploader_icon {
		font-size: 28px;
		color: #8c939d;
		width: 80px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 80px;
		height: 80px;
		display: block;
	}

	/* 用户名称 */
	.center_main_top_username {
		display: inline-block;
		vertical-align: middle;
	}

	.center_main_top_username>div+div {
		margin-top: 10px;
	}

	.center_main_top_username>div>span {
		margin-left: 10px;
		font-size: 20px;
		font-weight: bold;
	}

	/* 用户信息部分 */
	.center_main_top_info {
		padding: 0 40px;
		border-bottom: 1px solid #ddd;
	}

	.center_main_top_info .el-col {
		margin-bottom: 20px;
	}

	/* 容器 */
	.center_main_top_info_item {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	/* 图标 */
	.center_main_top_info_item>img {
		display: inline-block;
		vertical-align: bottom;
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}

	/* 订单数量盒子 */
	.center_main_top_order {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: nowrap;
	}

	/* 数量容器 */
	.center_main_top_order>.center_main_top_order_num {
		width: 25%;
		text-align: center;
	}

	.center_main_top_order>.center_main_top_order_num>a {
		display: block;
		padding: 30px 0;
		color: #606266
	}

	.center_main_top_order>.center_main_top_order_num>a:hover {
		color: #FF6700
	}

	/* 间隔线 */
	.center_main_top_order_border {
		font-weight: bold;
	}
</style>
